import { EXEMPT_PAGES } from '../constants/acceptConditions';

export const pageExemptFromConditionAcceptance = route => {
  return EXEMPT_PAGES.includes(route);
};
